import { gql } from "@apollo/client";

export const RETRY_FAILED_AUTO_SOAP = gql`
  mutation retryFailedAutoSoap(
    $noteUuid: String
    $jobType: String
    $templateUuid: String
  ) {
    retryFailedAutoSoap(
      noteUuid: $noteUuid
      jobType: $jobType
      templateUuid: $templateUuid
    ) {
      ok
    }
  }
`;
